<template>
  <div class="flex flex-column align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-12 md:w-10 lg:w-8 xl:w-8 mb-2">
      <template #title>PRIDANIE VIACERÝCH KUSOV</template>
      <template #subtitle >
        <div class="mb-3 border-solid border-1 surface-border">
        </div>

      </template>
      <template #content>
          
          <form @submit.prevent="submitHandler" name="itemForm">
            <div class="grid">

              <div class=" col-12 md:col-6 lg:col-6 p-2">

                <div class="field">
                  <label for="item-category">Kategória</label>

                  <PrimevueSelect
                      id="item-category"
                      v-model="selectedCategory"
                      :options="categories"
                      optionLabel="name"
                      placeholder="Vyber kategóriu"
                      class="w-full"
                      :class="`${v$.selectedCategory.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.selectedCategory.$error"
                      @change="selectCategory(selectedCategory.id)"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value.id != 0" class="">
                          <div>{{ slotProps.value.name }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                        <div class="">
                           <div>{{ slotProps.option.name }}</div>
                        </div>
                    </template>
                  </PrimevueSelect>  
                  <div
                      v-for="(error, index) of v$.selectedCategory.$errors"
                      :key="index"
                      class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>                            

                <div class="field">
                  <label for="item-product">Produkt</label>
                  <div class="flex align-items-center justify-content-between gap-1" >
                    <PrimevueSelect
                        id="item-product"
                        :disabled="!selectedCategory.name"
                        v-model="selectedProduct"
                        filter
                        :options="products"
                        optionLabel="code"
                        placeholder="Vyber produkt"
                        class="w-full"
                        :class="`${v$.selectedProduct.$error ? 'bg-red-200' : ''}`"
                        :invalid="v$.selectedProduct.$error"
                        @change="selectProduct()"
                    >
                      <template #value="slotProps">
                        <div v-if="slotProps.value.id != 0" class="">
                            <div>{{ slotProps.value.code }}</div>
                        </div>
                        <span v-else>
                          {{ slotProps.placeholder }}
                        </span>
                      </template>
                      <template #option="slotProps">
                          <div class="">
                            <div>{{ slotProps.option.code }} * {{ slotProps.option.name }}</div>
                          </div>
                      </template>
                    </PrimevueSelect>  

                    <PrimevueButton type="button" v-tooltip.top="{ value: 'Zobrazenie a výber produktov' }" class="products"
                      icon="pi pi-table" @click="this.visibleProducts = true" text severity="primary" size="large"
                    />
                  </div>
                  <div
                      v-for="(error, index) of v$.selectedProduct.$errors"
                      :key="index"
                      class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>                            

                <div class="field">
                  <label for="item-name">Názov</label>
                  <InputText class="w-full" 
                    disabled
                    v-model="stockItem.product.name"
                    type="text"
                    name="item-name"
                    id="item-name"
                  >
                  </InputText>
                </div>

                <div class="flex justify-content-center">
                  <!-- Náhľad obrázka -->
                  <div
                    class="image-container"
                    v-if="stockItem.product.image"
                    
                  >
                    <!-- Obrázok -->
                    <img :src="stockItem.product.image" alt="Preview Image" class="preview-image"/>
                
                  </div>
              
                  <!-- Štvorcové tlačidlo na výber obrázka, ak nie je žiadny obrázok -->
                  <div
                    class="image-container placeholder"
                    v-else
                  >
                  <i class="pi pi-image placeholder-icon"></i>
                  </div>
                </div>

              </div>

              <div class="col-12 md:col-6 lg:col-6 p-2">

                <div class="field">
                  <label for="item-length">Dĺžka</label>
                  <InputNumber class="w-full" inputId="item-length" :useGrouping="false"
                    :disabled="!(selectedCategory.name && selectedProduct.code)"
                    v-model="stockItem.length"
                    name="item-length"
                    id="item-length"
                    :inputClass="`${v$.stockItem.length.$error ? 'bg-red-200' : ''}`"
                    :invalid="v$.stockItem.length.$error"
                  >
                  </InputNumber>
                  <div
                    v-for="(error, index) of v$.stockItem.length.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>            

                <div class="field">
                  <label for="item-number">Počet kusov</label>
                  <InputNumber class="w-full" inputId="item-number" :useGrouping="false"
                    :disabled="!(selectedCategory.name && selectedProduct.code)"
                    v-model="numberOfItems"
                    name="item-number"
                    id="item-number"
                    :inputClass="`${v$.numberOfItems.$error ? 'bg-red-200' : ''}`"
                    :invalid="v$.numberOfItems.$error"
                  >
                  </InputNumber>
                  <div
                    v-for="(error, index) of v$.numberOfItems.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>            

                
                <div class="field">
                  <div class="flex align-items-center justify-content-between" style="margin-bottom: 0.45rem;">
                    <span class="">Farba</span>
                    <div class="flex align-items-center justify-content-right"> 
                      <label for="imitation" class="mr-2">Imitácia dreva</label>
                      <PrimevueCheckbox 
                        v-model="imitation" inputId="imitation" name="imitation" :binary="true"
                        @change="setColors()"
                      />
                      
                    </div>
                  </div>
                  <PrimevueSelect
                      id="item-color"
                      :disabled="!(selectedCategory.name && selectedProduct.code)"
                      v-model="selectedColor"
                      :options="colors"
                      optionLabel="code"
                      placeholder="Vyber farbu"
                      class="w-full"
                      :class="`${v$.selectedColor.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.selectedColor.$error"
                  >
                  <template #value="slotProps">
                    <div v-if="slotProps.value.id != 0" class="flex align-items-center">
                        <div
                          class="color-box mr-2"
                          :style="{ backgroundColor: slotProps.value.colorHash }"
                        ></div>  
                        <div>{{ slotProps.value.code }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                      <div class="flex align-items-center">
                          <div
                            class="color-box mr-2"
                            :style="{ backgroundColor: slotProps.option.colorHash }"
                          ></div>  
                          <div>{{ slotProps.option.code }}</div>
                      </div>
                  </template>
                  </PrimevueSelect>
                  <div
                    v-for="(error, index) of v$.selectedColor.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div> 

                <div class="field">
                  <label for="item-type">Typ</label>
                  <InputText class="w-full" 
                    :disabled="!(selectedCategory.name && selectedProduct.code)"
                    v-model="stockItem.type"
                    type="text"
                    name="item-type"
                    id="item-type"
                  >
                  </InputText>

                </div>

                <div class="field">
                  <label for="item-location">Umiestnenie</label>
                  <InputText class="w-full" 
                    :disabled="!(selectedCategory.name && selectedProduct.code)"
                    v-model="stockItem.location"
                    type="text"
                    name="item-location"
                    id="item-location"
                  >
                  </InputText>

                </div>

                <div class="field mb-3">
                  <div class="flex align-items-center justify-content-left"> 
                    <PrimevueCheckbox :disabled="!(selectedCategory.name && selectedProduct.code)"
                       v-model="stockItem.wholePiece" inputId="wholePiece" name="wholePiece" :binary="true"/>
                    <label for="wholePiece" class="ml-2">Celý kus</label>
                  </div>
                </div>

              </div>

            </div>           

            
            <div class="mt-3 mb-3 border-solid border-1 surface-border"></div>
            
            <div class="mt-2 flex flex-wrap justify-content-center gap-3">
                <PrimevueButton type="submit" label="Pridať kusy" text raised class="uppercase"/>
                <router-link to="/mod-stock/stock-items">
                      <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
                </router-link>
            </div>
          </form>
        </template>
    </PrimevueCard>
    
    <PrimevueDialog v-model:visible="this.visibleProducts" header="Produkty" :style="{ width: '60rem' }"> 
      <div class="grid">
        <div v-for="(prod,index) in this.products" v-bind:key="index" class="p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4">
            <PrimevueButton outlined  
              class="p-1"  @click="setSelectProduct(prod) "
              @mouseover="this.hoverIndex = index"
              @mouseleave="this.hoverIndex = null"
              :style="buttonStyle(index)"   
              >
              <div class="grid w-full h-full">
                <div class="col-6 p-2">
                  <div class="text-left font-bold">{{ prod.code }}</div>
                  <div class="text-left mt-5">{{ prod.name }}</div>
                </div>
                <div class="col-6 p-1 flex justify-content-center">
                  <div class="w-full h-full flex justify-content-center align-items-center">
                    <img :src="prod.image" 
                        :style="`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`"
                        @load="checkImageSize(index,$event)"
                        alt="Preview Image" class=""/>
                  </div>
                </div>
              </div> 
            </PrimevueButton>
        </div>
      </div>  
    </PrimevueDialog>

    <ConfirmDialog></ConfirmDialog>
  </div>
  
</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
import PrimevueSelect from "primevue/dropdown";
import PrimevueCard from 'primevue/card';
import PrimevueCheckbox from 'primevue/checkbox';
//import PrimevueTag from "primevue/tag";
import { required, helpers  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import {FilterMatchMode} from "primevue/api";
import PrimevueDialog from 'primevue/dialog';

import Utils from './utils';

const notBeZero = (value : number) => value > 0

const requiredWhenReserved = (param) =>
  helpers.withParams(
    { type: 'requiredWhenReserved', value: param },
    (value:number) => !param || value > 0
  ) 


export default {
  name: "StockItemBulkAddition",
  components: {
      
      PrimevueCheckbox,
      PrimevueButton,
      PrimevueSelect,
      PrimevueCard,
      PrimevueDialog,

  },
  data() {
    return {
      store,
      hoverIndex: null,
      numberOfItems: 0,
      visibleProducts: false,
      imitation: false,
      cutLengthIsWrong: false,
      cutLength: null,
      action: "",
      typeOfAction: "",
      oldLocation: "",
      oldOrderCode: 0,
      isMovement: false,
      routeParams: null,
      categories: [],
      selectedCategory: {id:0,name:""},
      colors: [],
      selectedColor: {id:0,code:""},
      products: [],
      selectedProduct: {id:0,code:"",name:""},
      stockItem: {
        id: 0,
        code: "",
        product:{id:0,code:"",name: "",image: ""},
        length: 0,
        location: "",
        category: {},
        color: {id:0,code:""},
        order:{id:0,orderCode:0,customerLastName:"",customer:{lastName:"",city:""}},
        type: "",
        wholePiece: true,
        reserved: false,
        eliminated: false,
        eliminatedAt: null,
        reservedAt: null,
      },
      orderOptions: [],
      selectedOrder: null,
      visibleSelect: false,
      selectLoading: false,
      orderFilters : {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      selectParams: {
        first: 0,
        rows: 100,
        totalRecords: 0,
        filters:{global: "",
                 table:"order",
                 globalFilterFields: ['OrderCode', 'CustomerId__LastName','CustomerId__City']
                },

      },
    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },

  computed: {
    Utils() {
      return Utils
    },
  },

  validations () {
    return {
      stockItem: {
        length: { notBeZero: helpers.withMessage('Dĺžka nesmie byť nulová', notBeZero),
               
              },
   
      },

      selectedCategory: {
           name: { required: helpers.withMessage('Kategória nesmie byť prázdna', required)},
                
              }, 
      selectedProduct: {
           code: { required: helpers.withMessage('Product nesmie byť prázdny', required)},
                
              },                         
      selectedColor: {
           code: { required: helpers.withMessage('Farba nesmie byť prázdna', required)},
                
              },     
      numberOfItems: { notBeZero: helpers.withMessage('Počet kusov nesmie byť nulový', notBeZero),
               
              },         
      
    }
  },
  methods: {

    buttonStyle(index) {
      return {
        height: '172px',
        width: '295px',
        borderWidth: this.hoverIndex === index ? '2px' : '1px',
        borderColor: this.hoverIndex === index ? '#0000FF' : '#ccc', // Farba okraja
        transition: 'border-width 0.2s ease-in-out,border-color 0.2s ease-in-out'
      };
    },

    async submitHandler() {
      const result = await this.v$.$validate()
      //console.log("error: ",requiredWhenReserved)
      if (!result) {
        // notify user form is invalid
        return
      }

      //const stockItemId = parseInt(String(this.routeParams.stockItemId), 10)

      const formData = {
        id: this.stockItem.id,
        code: this.stockItem.code,
        location: this.stockItem.location,
        length: this.stockItem.length,
        type: this.stockItem.type,
        wholePiece: this.stockItem.wholePiece,
        reserved: this.stockItem.reserved,
        reservedAt: this.stockItem.reservedAt,
        product: this.stockItem.product,
        color: this.selectedColor,
        order: this.stockItem.order,
        eliminated: this.stockItem.eliminated,
        eliminatedAt: this.stockItem.eliminatedAt,

      }


      let method = "POST"
      let url = "/add-multiple-items/"+String(this.numberOfItems)
      
      fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.data.message);

              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Kusy boli uložené"
              })
              router.push('/mod-stock/stock-items')
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení kusov" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení kusov" + error
            })
          })

    },
    
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    checkImageSize(index,event) {
      this.products[index].imageWidth = event.target.naturalWidth;
      this.products[index].imageHeight = event.target.naturalHeight;
    },

    setSelectProduct(product){

      this.selectedProduct = product
      this.visibleProducts = false
      this.selectProduct()
    },

    setReserved(){
      if (this.stockItem.reserved){
        this.stockItem.reservedAt = new Date()
      }else{
        this.stockItem.reservedAt = null
        this.stockItem.order = {id:0,orderCode:0,customer:{lastName:"",city:""}}
      }
    },

    validateForm() {
      this.isSubmitted = true; // Mark the form as submitted to show validation feedback
  
    },

    selectCategory(categoryId:number){
      fetch(this.store.Api_url + "/v1/product?query=deleted:0,category_id:"+categoryId, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Zoznam produktov sa nepodarilo načítať"
              })
            } else {
              
              this.products = responseData.data

            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní produktov" + error);
      })
    },

    selectProduct(){
      this.stockItem.product = this.selectedProduct
      this.stockItem.length = this.selectedProduct.length
      //__icontains
      //this.stockItem.code = this.selectedProduct.code + "_"
      // zistím počet všetkých existujúcich kusov podľa prefixu

    },

    selectOrder(order){
      //console.log("Order:", order)
        this.stockItem.order = order
        //this.stockItem.customer = order.customer
        this.visibleSelect = false
    },
    onOrderPage(event) {
        this.selectParams.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyDataOrders(this.selectParams)
    },
      
    onOrderFilter() {
        this.selectParams.filters.global = this.orderFilters.global.value
        this.selectParams.first = 0
        
        if(this.selectParams.filters.global.length > 2){
           this.loadLazyDataOrders(this.selectParams)
          }
    },

    initSelectFilters(){
        this.selectParams.first = 0
        this.selectParams.rows = 100
        this.selectParams.filters.global = ""
        this.orderfilters = {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS},

        }
        this.isMovement = false
        this.action = ""
        this.typeOfAction = ""
    },

    setColors(){

      const imitat = this.imitation ? "1" : "0"

      fetch(this.store.Api_url + "/v1/color?query=deleted:0,imitation:"+imitat, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: "Zoznam farieb sa nepodarilo načítať",
                position: "top"
              })
            } else {
              this.colors = responseData.data
            }
          })
          .catch((error) => {
            notie.alert({
                type: 'error',
                text: "Chyba pri načítaní farieb: "+error,
                position: "top"
              })
            //this.$emit('error', "Chyba pri načítaní farieb" + error);
      })
    },

    loadData(){

      this.setColors()

      fetch(store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + responseData.data.message,
                      position: "top"
                    })           
            } else {
              //console.log(responseData);
              this.categories = responseData.data

            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + error,
                      position: "top"
            })           
      });
      

    },

    loadLazyDataOrders(params) {
        this.selectLoading = true;

        let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

        fetch(`${store.Api_url}${this.store.basicUrlFilterOrders}${queryParams}`, Security.requestOptions("POST",params.filters))
        .then((response) => response.json())
        .then((responseData) => {
          if (!responseData.error) {
            if (responseData.data){
              this.orderOptions = responseData.data
            }else{this.orderOptions = []}
            this.selectParams.totalRecords = responseData.totalRecords
            this.selectLoading = false;
          }
        })
        .catch((error) => {
          this.orderOptions = []
          this.selectLoading = false;
        })
      },


  },

  beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
        this.routeParams = to.params
        store.selectModul = this.$route.path.split("/")[1]
        //console.log("Route update");
        this.initSelectFilters()
        this.loadLazyDataOrders(this.selectParams)

        this.loadData()  

        next()
      }
  },

  beforeMount() {
    
    if (Security.requireToken()){
      //console.log("Before mount");
      this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]
      
      this.initSelectFilters()
      this.loadLazyDataOrders(this.selectParams)
     
      this.loadData()


    }

  }
}
</script>



<style scoped>

</style>